<script setup>
import {ref, computed, watch} from 'vue'
import {useItemDataStore} from '@/stores/itemData'
import {useFormStore} from '@/stores/form'
import FormSidebarBtn from "@/common/form/FormSidebarBtn.vue"
import api from '@/services/api'

const props = defineProps({
    formId: {
        type: String,
        required: true
    }
})

// Pinia Stores
const itemDataStore = useItemDataStore()
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// --- State ---
const order = ref({})

// --- Computed ---
const tableName = computed(() => formStore.value?.tableName)
const id = computed(() => formStore.value?.id)

const show = computed(() => tableName.value === 'm_basket_orders')

const isDisabled = computed(() => order.value.orderStatus !== 'Completed')

watch(() => [show.value, id.value], async ([shouldShow, currentId]) => {
    if (shouldShow && currentId) {
        order.value = await itemDataStore.get({
            tableName: 'm_basket_orders',
            id: currentId
        })
    } else {
        order.value = {}
    }
}, {immediate: true})

// --- Methods ---
const onClick = async () => {
    if (isDisabled.value) {
        alert("The order's status must be 'Completed'.")
        return
    }

    // Toggle logic: If truthy, set to 0. If falsy, set to current Unix timestamp.
    const newValue = order.value.requestAReview
        ? 0
        : Math.floor(Date.now() / 1000)

    // Update local state immediately for UI snappiness
    order.value.requestAReview = newValue

    const orderId = order.value.id

    try {
        await api.patch(`api/component/m_basket_orders/${orderId}`, {
            requestAReview: newValue
        })

        // Sync the global itemData cache via Pinia
        itemDataStore.set({
            tableName: 'm_basket_orders',
            id: orderId,
            property: 'requestAReview',
            value: newValue
        })
    } catch (err) {
        // Handle error if needed
    }
}
</script>

<template>
    <FormSidebarBtn v-if="show" :disabled="isDisabled" @click.prevent.stop="onClick">
        <span
            :class="{ 'bi-square': !order.requestAReview, 'bi-check-square': order.requestAReview }"
            class="me-2"
        />
        Request a review
    </FormSidebarBtn>
</template>